import { useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { ColorsName } from 'styles/theme';

const useBodyBackgroundColor = (backgroundColor: ColorsName): string | void => {
  const theme = useContext(ThemeContext);
  useEffect(() => {
    window.document.body.style.backgroundColor = theme.color[backgroundColor];

    return () => {
      window.document.body.style.backgroundColor = '';
    };
  }, [backgroundColor, theme.color]);
};

export default useBodyBackgroundColor;
